import React, { useState } from "react";
import { PageHeader } from "@ant-design/pro-components";
import { Button, DatePicker, Space, message } from "antd";
import { Dayjs } from "dayjs";
import {
  exportClientReportLocal,
  exportMarketingReport,
} from "../../services/marketing.service";

const { RangePicker } = DatePicker;

const ReportClients: React.FC = () => {
  const [dates, setDates] = useState<[Dayjs | null, Dayjs | null] | null>(null);
  const [loadingERP, setLoadingERP] = useState(false);
  const [loadingLocal, setLoadingLocal] = useState(false);

  const getFormattedDates = () => {
    if (!dates || !dates[0] || !dates[1]) {
      message.warning("Selecciona un rango de fechas");
      return null;
    }

    return {
      from: dates[0].format("YYYY-MM-DD"),
      to: dates[1].format("YYYY-MM-DD"),
    };
  };

  const handleReportLocal = async () => {
    const formattedDates = getFormattedDates();
    if (!formattedDates) return;

    const { from, to } = formattedDates;

    try {
      setLoadingLocal(true);

      const response = await exportClientReportLocal(from, to);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `client-sales-${from}-${to}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("No se pudo generar el reporte");
    } finally {
      setLoadingLocal(false);
    }
  };

  const handleReportMarketing = async () => {
    const formattedDates = getFormattedDates();
    if (!formattedDates) return;

    const { from, to } = formattedDates;

    try {
      setLoadingERP(true);

      const response = await exportMarketingReport(from, to);

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `marketing-report-${from}-${to}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("No se pudo generar el reporte de marketing");
    } finally {
      setLoadingERP(false);
    }
  };

  return (
    <div>
      <PageHeader title="Reportes de Clientes - Marketing" />

      <Space direction="vertical" size="large">
        <RangePicker
          onChange={(values) =>
            setDates(values as [Dayjs | null, Dayjs | null])
          }
        />

        <Button
          type="primary"
          loading={loadingERP}
          onClick={handleReportMarketing}
        >
          Reporte Clientes ERP
        </Button>

        <Button
          type="primary"
          loading={loadingLocal}
          onClick={handleReportLocal}
        >
          Reporte Clientes Sistema Antiguo
        </Button>
      </Space>
    </div>
  );
};

export default ReportClients;
